<div class="address-section">
    <div class="address-top-section">
        <div class="back-icon-container">
            <mat-icon class="icon" (click)="goBack()">arrow_back</mat-icon>
            <p class="address-heading">{{ "addressList.label.address" | translate }}</p>
        </div>
        <app-button variant="white" buttonClass="shadow-btn" (click)="addOrEditAddress()">
            {{ "addressList.button.addAddress" | translate }}
        </app-button>
    </div>
    <div class="address-bottom-section">
        <div class="address-container">
            @for (address of currentUserAddresses; track $index) {
            <mat-card class="address-details">
                <div class="radio-name-row">
                    <p class="customer-name">{{ address.name }}</p>
                    <div class="badges-container">
                        <span class="address-type">{{ address.addressType }}</span>
                        <span class="default-text" *ngIf="address.isDefault">{{
                            "addressList.label.default" | translate
                        }}</span>
                    </div>
                </div>
                <p class="address">{{ address.address }}</p>
                <p class="city">{{ address.city }},{{ address.state }},{{ address.pincode }}</p>
                <p class="mobile">Mobile : {{ address.mobileNumber }}</p>

                <div class="address-btn-container">
                    <app-button variant="hero" (click)="addOrEditAddress(address)">
                        {{ "addressList.button.edit" | translate }}
                    </app-button>
                    <app-button
                        variant="white"
                        buttonClass="shadow-btn"
                        *ngIf="!address.isDefault"
                        (click)="deleteAddress(address)"
                    >
                        {{ "addressList.button.delete" | translate }}
                    </app-button>
                    <app-button variant="hero" (click)="setAsDefault(address.id)" *ngIf="!address.isDefault">
                        {{ "addressList.button.SetAsDefault" | translate }}
                    </app-button>
                </div>
            </mat-card>
            }
        </div>
    </div>
</div>
